/* SwitchToSiteExplorerRender.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
//const _ = require('lodash');

class SwitchToConfigAuditRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("network-discovery-view-gl");
        this._logger = this._model.logger;
    }

    shutdown() {
        this._model = undefined;
        this._rootElem = undefined;
        this._logger = undefined;
        return Promise.resolve();
    }

    get rootElement() {
        return this._rootElem;
    }

    get model() {
        return this._model;
    }

    render() {
        setTimeout(() => {
            this.model._gameEditor._cabinetCmpnt.emit("ExplorerChanged");
        }, 0);

        this.model._gameEditor.openLMRBExplorer(Registrations.SITE_EXPLORER_ENTITY_LMRB);
    }
}

module.exports = SwitchToConfigAuditRenderer;
